<template>
  <div class="flex flex-col w-full h-auto mb-12">
    <!-- Header -->
    <div class="flex w-full h-auto justify-center items-center">
      <span class="Helvetica text-2xl font-bold text-primary-500 justify-center normal-case">{{
        $t('shipping_informations') }}sss</span>
    </div>
    <div v-if="currentUser.type != 'Seller'" class="flex py-2 w-full h-auto justify-center items-center">
      <div class="flex">
        <a class="mr-5 tracking-wide text-primary-700 font-bold rounded border-2 border-yellow-400 hover:border-green-700 hover:bg-primary-700 hover:text-white shadow-md py-2 px-6 inline-flex items-center transition duration-300 cursor-pointer"
          @click="OpenClosePopupModal('open', 'postponed')">{{ $t('postponed') }}</a>
        <a class="tracking-wide text-primary-700 font-bold rounded border-2 border-yellow-400 hover:border-green-700 hover:bg-primary-700 hover:text-white shadow-md py-2 px-6 inline-flex items-center transition duration-300 cursor-pointer"
          @click="OpenClosePopupModal('open', 'unreachable')">{{ $t('unreachable') }}</a>
      </div>
    </div>
    <!-- ******************************** -->
    <div class="px-6">
      <div class="w-full">
        <div class="space-x-2 w-full shadow-xs pt-1 mb-1 rounded-lg">
          <div v-if="
            item.status === 'delivered' ||
            item.status == 'cancelled' ||
            item.status == 'refused'
          " class="relative flex border border-green-600 border-dashed m-2 py-2 px-2 justify-center items-center">
            <div v-if="item.status == 'cancelled' || item.status == 'refused'"
              class="border mx-1 hover:border-orange-500 w-1/2 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="status" class="bg-white text-gray-700 px-1">{{
                    $t('sous_status')
                  }}</label>
                </p>
              </div>
              <p>
                <select @change="onChangeStatus($event)" :disabled="currentUser && currentUser.type == 'Seller'"
                  :style="colorStatus(item.type)" v-model="item.type"
                  class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                  <option class="bg-white" selected :value="null">
                    {{ $t('action') }}
                  </option>
                  <option class="bg-white text-gray-600" v-for="(value, index) in typetatus" :key="index"
                    :value="value">
                    {{ value }}
                  </option>
                </select>
              </p>
            </div>
            <div v-if="item.status === 'delivered'"
              class="mx-1 border hover:border-orange-500 w-1/2 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">Invoiced
                    <svg class="inline-block fill-current mx-2" xmlns="http://www.w3.org/2000/svg" width="24"
                      height="24" viewBox="0 0 24 24">
                      <path
                        d="M12.164 7.165c-1.15.191-1.702 1.233-1.231 2.328.498 1.155 1.921 1.895 3.094 1.603 1.039-.257 1.519-1.252 1.069-2.295-.471-1.095-1.784-1.827-2.932-1.636zm1.484 2.998l.104.229-.219.045-.097-.219c-.226.041-.482.035-.719-.027l-.065-.387c.195.03.438.058.623.02l.125-.041c.221-.109.152-.387-.176-.453-.245-.054-.893-.014-1.135-.552-.136-.304-.035-.621.356-.766l-.108-.239.217-.045.104.229c.159-.026.345-.036.563-.017l.087.383c-.17-.021-.353-.041-.512-.008l-.06.016c-.309.082-.21.375.064.446.453.105.994.139 1.208.612.173.385-.028.648-.36.774zm10.312 1.057l-3.766-8.22c-6.178 4.004-13.007-.318-17.951 4.454l3.765 8.22c5.298-4.492 12.519-.238 17.952-4.454zm-2.803-1.852c-.375.521-.653 1.117-.819 1.741-3.593 1.094-7.891-.201-12.018 1.241-.667-.354-1.503-.576-2.189-.556l-1.135-2.487c.432-.525.772-1.325.918-2.094 3.399-1.226 7.652.155 12.198-1.401.521.346 1.13.597 1.73.721l1.315 2.835zm2.843 5.642c-6.857 3.941-12.399-1.424-19.5 5.99l-4.5-9.97 1.402-1.463 3.807 8.406-.002.007c7.445-5.595 11.195-1.176 18.109-4.563.294.648.565 1.332.684 1.593z" />
                    </svg></label>
                </p>
              </div>
              <p>
                <select v-model="item.is_paid"
                  class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                  <option class="bg-white" selected :value="null">
                    {{ $t('status') }}
                  </option>
                  <option class="bg-white text-gray-600" v-for="(value, index) in paidtatus" :key="index"
                    :value="value">
                    {{ value }}
                  </option>
                </select>
              </p>
            </div>
          </div>
          <div class="flex w-full justify-between items-center h-auto p-6">
            <div class="flex w-full">
              <span class="rounded-full h-12 w-12 bg-gray-200">
                <i class="material-icons p-3 text-primary-500">local_mall</i>
              </span>
              <div class="ml-3 w-full p-2">
                <div class="w-full flex text-base font-semibold text-gray-600">
                  <p class="w-1/2">{{ $t('shipping_informations') }}</p>
                </div>
                <div class="bg-white rounded-lg p-6 pb-0">
                  <div class="grid lg:grid-cols-2 gap-6">
                    <div
                      class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerAddress" class="bg-white text-gray-700 px-1">{{ $t('address_shipping')
                            }}<span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <textarea id="customerAddress" type="text" v-model="item.address"
                          class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                      </p>
                    </div>
                    <div v-if="
                      currentUser.type == 'Admin' ||
                      currentUser.type == 'CEO' ||
                      currentUser.type == 'StockManager'
                    "
                      class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="shippdate" class="bg-white text-gray-700 px-1">{{ $t('shipping_date') }}
                            <span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <input id="shippdate" type="date" v-model="item.date"
                          class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      </p>
                    </div>
                    <!-- <div v-if="item.country && item.country != 'MA'" class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                    <label for="category" class="bg-white text-gray-700 px-1">{{$t('zone_shipping')}} <span :class="$colors.required">*</span></label>
                                                    </p>
                                                </div>
                                                <p>
                                                 <v-select v-bind:class="{ disabled: currentUser.type=='Courier' }"  label="name" v-model="item.zone" :options="zones" ></v-select>
                                                </p>
                                            </div> -->
                    <div
                      class="border h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="country" class="bg-white text-gray-700 px-1">{{ $t('country') }}
                            <span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <v-select v-model="item.country" :options="dataCountry" v-bind:class="{ disabled: true }"
                          label="name">
                          <template slot="option" slot-scope="option">
                            <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                            {{ option.name }}
                          </template>
                        </v-select>
                      </p>
                    </div>
                    <div
                      class="border h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="courier" class="bg-white text-gray-700 px-1">{{ $t('courier') }}
                            <span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <v-select v-bind:class="{
                          disabled: currentUser.type == 'Courier',
                        }" label="fullName" @search="searchCouriers($event, 'Courier')" v-model="item.courier"
                          :options="couriers"></v-select>
                      </p>
                    </div>
                    <div
                      class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="city" class="bg-white text-gray-700 px-1">{{ $t('city') }}
                            <span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <input id="city" disabled type="text" v-model="item.order.customer.city"
                          class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      </p>
                    </div>
                    <div v-if="item.country"
                      class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="Frais" disabled class="bg-white text-gray-700 px-1">{{ $t('shipping_cost') }}
                            <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          </label>
                        </p>
                      </div>
                      <p>
                        <input id="Frais" disabled :value="item.orderObjet.feesShipp == -1
                            ? feesShipp.price
                            : item.orderObjet.feesShipp
                          " type="text" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      </p>
                    </div>
                    <div class="flex">
                      <div
                        class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="status" class="bg-white text-gray-700 px-1">{{ $t('status') }}
                              <span :class="$colors.required">*</span>
                            </label>
                          </p>
                        </div>
                        <p>
                          <select @change="onChangeStatus($event)" :disabled="(currentUser && currentUser.type == 'Seller') ||
                            item.status == 'rembourser'
                            " :style="colorStatus(item.status)" v-model="item.status"
                            class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                            <option class="bg-white" selected :value="null">
                              {{ $t('status') }}
                            </option>
                            <option class="bg-white text-gray-600" v-for="(value, index) in datatatus" :key="index"
                              :value="value">
                              {{ value }}
                            </option>
                          </select>
                        </p>
                      </div>
                      <button v-if="(currentUser && currentUser.type != 'Seller')" @click="changeOnlyStatus"
                        class="bg-green-500 text-white px-2 py-1 text-sm rounded">Apply</button>
                    </div>

                    <div
                      class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerAddress" class="bg-white text-gray-700 px-1">{{ $t('comment')
                            }}<span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <textarea id="customerAddress" type="text" v-model="item.comment"
                          class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                      </p>
                    </div>
                    <div v-if="
                      item.status == 'cancelled' || item.status == 'refused'
                    "
                      class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerAddress" class="bg-white text-gray-700 px-1">{{
                            $t('cancelatation_comment_shipping')
                            }}</label>
                        </p>
                      </div>
                      <p>
                        <textarea id="customerAddress" type="text" v-model="item.comment"
                          class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-cc w-full s-sidebarwidget s-sidebarwidget__yellow s-anchors s-anchors__grayscale">
          <div class="d-block p-0 m-0">
            <div class="s-sidebarwidget--header flex s-sidebarwidget__small-bold-text fc-light d:fc-black-900 bb bbw1">
              <svg xmlns="http://www.w3.org/2000/svg" class="fill-current mr-2" width="20" height="20"
                viewBox="0 0 24 24">
                <path
                  d="M12 5.177l8.631 15.823h-17.262l8.631-15.823zm0-4.177l-12 22h24l-12-22zm-1 9h2v6h-2v-6zm1 9.75c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25z" />
              </svg>
              Change in order of cases
            </div>
            <div class="s-sidebarwidget--item">
              <table class="w-full">
                <tbody>
                  <tr>
                    <td><b>To prepare</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Prepared</b></td>
                  </tr>
                  <tr>
                    <td><b>Prepared</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Shipped</b></td>
                  </tr>
                  <tr>
                    <td><b>Shipped</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Delivered</b></td>
                  </tr>
                  <tr>
                    <td><b>Delivered</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Paid</b></td>
                  </tr>
                </tbody>
              </table>
              <hr class="hr-grey" />
              <table class="w-full">
                <tbody>
                  <tr>
                    <td><b>Shipped</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right">
                      <b>(Postponed Or Unreachable)</b>
                    </td>
                  </tr>
                  <tr>
                    <td><b>(Postponed Or Unreachable)</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Shipped</b></td>
                  </tr>
                </tbody>
              </table>
              <hr class="hr-grey" />
              <table class="w-full">
                <tbody>
                  <tr>
                    <td><b>Shipped Or Delivered</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Cancelled</b></td>
                  </tr>
                  <tr>
                    <td><b>Shipped Or Delivered</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Refused</b></td>
                  </tr>
                  <tr>
                    <td><b>Cancelled Or Refused</b></td>
                    <td>
                      <span><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                        </svg></span>
                    </td>
                    <td class="text-right"><b>Return</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ***************************************-->
    <!--*******************  Order refund ***************************************-->
    <!--  <div v-if="item.status=='return' && (currentUser.type=='Admin' || currentUser.type=='CEO' || currentUser.type=='StockManager')" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                    <div class="flex w-full mt-1">
                        <span class="rounded-full h-12 w-12 bg-gray-200">
                            <i class="material-icons p-3 text-primary-400 ">replay</i>
                        </span>

                        <div class="ml-5 w-full pb-4">
                            <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                 {{$t('order_refunded_products')}}
                            </div>

                            <div class="w-full space-y-4">
                                <div class="w-full">
                                    <table style="display: inline-table;"
                                        class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                                        <thead class="text-white">
                                            <tr
                                                class="bg-primary-400  flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                                <th class="p-2 justify-center">{{$t('products')}}</th>
                                                <th class="p-2 justify-center"> {{$t('quantity')}}</th>
                                                <th class="p-2 justify-center"> {{$t('quantity_returned')}}</th>                                            
                                            </tr>
                                        </thead>
                                        <tbody class="flex-1 sm:flex-none" v-for="it in item.order.details" :key="it._id">
                                            <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                                <td
                                                    class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                                                    <div class="flex space-x-10">
                                                        <div>
                                                            <img alt="..." :src="it.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                                                                class="h-16 w-16 rounded-md mx-auto" />
                                                        </div>
                                                        <div>
                                                            {{ it.product.name }}
                                                        </div>
                                                    </div>
                                                </td>
                                                 <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity }}</b></td>
                                                 <td class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                   
                                                    <div class="grid gap-4 " :class="CheckQteDefecteuseorderexist?'grid-cols-2':'grid-cols-1'">
                                                     <div class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500  tracking-wider"><b>{{$t('ok_good')}}</b></div>
		                                        	 <div v-if="CheckQteDefecteuseorderexist" class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500  tracking-wider"><b>{{$t('defective')}}</b></div>
                                                     <input v-model="it.product.qteChange" :disabled="CheckQteDefecteuseorderexist"  min="0" :max="it.quantity" type="number" class="border border-green-600  py-2 text-xs px-2 outline-none block h-full w-full">
                                                     <div v-if="CheckQteDefecteuseorderexist" class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity-it.product.qteChange }}</b></div>  
                                                    </div>
                                                 </td> 
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->
    <!--*******************  / Order refund ***************************************-->
    <!--*******************  Product returned ***************************************-->
    <span class="flex w-full px-6" :id="'return-' + item._id">
      <div v-if="item.type == 'return' || item.status == 'return'"
        class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
        <div class="flex w-full mt-1">
          <span class="rounded-full h-12 w-12 bg-gray-200">
            <i class="material-icons p-3 text-primary-400">local_mall</i>
          </span>
          <div class="ml-5 w-full pb-4">
            <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
              {{ $t('products_returned') }}
            </div>
            <div class="w-full space-y-4">
              <div class="w-full">
                <table class="min-w-full w-full">
                  <thead class="text-white">
                    <tr
                      class="bg-primary-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                      <th class="p-2 justify-center">{{ $t('image') }}</th>
                      <th class="p-2 justify-center">{{ $t('name') }}</th>
                      <th class="p-2 justify-center">
                        {{ $t('quantity_sent') }}
                      </th>
                      <th class="p-2 justify-center">
                        {{ $t('quantity_returned') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="flex-1 sm:flex-none">
                    <tr v-for="(it, index) in item.order.details" :key="index"
                      class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                      <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
                        <div>
                          <img :alt="it.product.name" :src="it.product.picture ||
                            'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                            " class="h-16 w-16 rounded-md mx-auto" />
                        </div>
                      </td>
                      <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                        <b>{{ it.product.name }}</b>
                      </td>
                      <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                        <span>{{ it.quantity }}</span>
                      </td>
                      <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                        <table class="min-w-full">
                          <thead>
                            <tr>
                              <th
                                class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider">
                                {{ $t('ok_good') }}
                              </th>
                              <th
                                class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider">
                                {{ $t('defective') }}
                              </th>
                            </tr>
                          </thead>
                          <tbody class="bg-white">
                            <tr>
                              <td class="px-6 py-4 border whitespace-no-wrap bg-primary-100">
                                <div class="flex items-center">
                                  <input id="Defective" @input="handleUpdate($event, index)" :disabled="data_return"
                                    type="number" :max="it.quantity" min="0" v-model="it.product.qteChange"
                                    class="py-2 border-4 border-light-orange-500 border-opacity-100 text-xs px-2 outline-none block h-full w-full" />
                                </div>
                              </td>
                              <td
                                class="px-6 py-4 border whitespace-no-wrap text-center text-red-600 bg-red-200 font-bold">
                                {{ it.quantity - it.product.qteChange }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import { changeShipmentStatus } from "../../services/shipments.service"
export default {
  props: {
    config: { required: true, type: Object },
    item: { default: [] },
    index: { type: Number },
    idWharhouse: { type: Object },
    currentUser: { type: Object },
    statusShipp: { type: Array },
    couriers: { type: Array },
    currency: { type: String },
    typesShipp: { type: Array },
    paidtatus: { type: Array },
    feesShipp: { type: Object },
    zones: { type: Array },
    dataCountry: { type: Array },
    CheckQteDefecteuseexist: { required: false },
    CheckQteReturnedexist: { required: false },
    CheckQteDefecteuseorderexist: { required: false },
  },
  data() {
    return {
      courier: [],
      datatatus: this.statusShipp,
      typetatus: this.typesShipp,
      data_return: this.CheckQteReturnedexist,
    };
  },
  watch: {
    CheckQteReturnedexist: function () {
      this.data_return = this.CheckQteReturnedexist;
    },
  },
  async mounted() {
    //    await this.getCurrentCourierZone(this.item.zone._id);

    let dataWhrahouseSetting = null;
    if (
      this.item.seller.settings &&
      this.item.seller.settings.length > 0 &&
      this.idWharhouse
    )
      dataWhrahouseSetting = await this.getElementInArray(
        this.item.seller.settings,
        this.idWharhouse._id,
      );
    if (
      !dataWhrahouseSetting ||
      (dataWhrahouseSetting && dataWhrahouseSetting.shipping)
    ) {
      // if (this.currentUser.type == 'StockManager') this.datatatus = ['to prepare', 'prepared', 'refused', 'cancelled'];
      if (this.currentUser.type == 'Livreur')
        this.datatatus = [
          'prepared',
          'to pick',
          'picked',
          'refused',
          'cancelled',
        ];
    } else {
      // if (this.currentUser.type == 'StockManager') this.datatatus = ['to prepare', 'prepared', 'refused', 'cancelled'];
      if (this.currentUser.type == 'Livreur')
        this.datatatus = [
          'prepared',
          'shipped',
          'delivered',
          'refused',
          'cancelled',
        ];
    }
    if (this.currentUser.type == 'Accountant') this.datatatus = ['delivered'];
    await this.CheckQteDefecteuseOrder();
    await this.CheckQteDefecteuse();
    await this.CheckQteReturned();

    //    if(this.item && this.item.status && this.item.status=='delivered')  this.typetatus=["pending", "paid"];
    //    if(this.item && this.item.status && (this.item.status=='cancelled' || this.item.status=='refused')) this.typetatus=["pending", "return"];
  },
  methods: {
    async changeOnlyStatus() {
      await changeShipmentStatus({ shipmentId: this.item._id, status: this.item.status })

    },
    setSelected(courier) {

    },
    handleUpdate(event, index) {
      if (event.target.value < event.target.min) {
        this.item.order.details[index].product.qteChange = event.target.min;
      }
      if (event.target.value > event.target.max) {
        this.item.order.details[index].product.qteChange = event.target.max;
      }
    },
    scrollTo(hash) {
      location.hash = '#return-' + hash;
    },
    onChangeStatus(event) {
      if (event.target.value === 'return') {
        this.scrollTo(this.item._id);
      }
    },
    async getElementInArray(data, value) {
      if (value) {
        var result = data.filter(function (o) {
          let whar = o.warehouse;
          if (o.warehouse._id) whar = o.warehouse._id;
          return whar == value.toString();
        });
        return result ? result[0] : null; // or undefined
      } else return null;
    },
    searchCouriers: function (value, event) {
      this.$emit('searchCouriers', value, event);
    },
    async getCurrentCourierZone(id) {
      const filter = {
        type: 'Courier',
        limit: 2000,
        zones: id,
      };
      const res = await this.$server.search('users', filter);
      if (res.content.results) {
        this.courier = res.content.results;
      } else this.courier = [];
    },
    async getCourierZone(zone) {

      this.item.courier.fullName = '';
      // 
      const filter = {
        type: 'Courier',
        limit: 2000,
        zones: zone._id,
      };
      const res = await this.$server.search('users', filter);
      if (res.content.results) {
        this.courier = res.content.results;
      } else this.courier = [];
    },
    CheckQteDefecteuse: function (val) {
      this.$emit('CheckQteDefecteuse', this.item);
    },
    CheckQteReturned: function (val) {
      this.$emit('CheckQteReturned', this.item);
    },
    OpenClosePopupModal: function (val, method) {
      this.$emit(
        'OpenClosePopupModalReporte',
        val,
        method,
        this.item,
        this.index,
      );
    },
    CheckQteDefecteuseOrder: function () {
      this.$emit('CheckQteDefecteuseOrder', this.item);
    },
    colorStatus(status) {
      switch (status) {
        case 'to prepare':
          return 'color: rgb(233 147 19); border-color: rgb(233 147 19);';
        case 'prepared':
          return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
        case 'shipped':
          return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
        case 'delivered':
          return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
        case 'paid':
          return 'color:rgb(58 217 18); border-color: rgb(58 220 18);';
        case 'cancelled':
          return 'color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);';
        case 'refused':
          return 'color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);';
        case 'postponed':
          return 'color: rgb(227 129 210); border-color: rgb(227 129 210);';
        case 'unreachable':
          return 'color: rgb(141 8 118); border-color: rgb(141 8 118);';
        case 'pending return':
          return 'color: rgb(227 129 210); border-color: rgb(227 129 210);';
        case 'return':
          return 'color: rgb(141 8 118); border-color: rgb(141 8 118);';
        case 'picked up':
          return 'color: rgb(75, 0, 130); border-color: rgb(75, 0, 130);';
        case 'reprogram':
          return 'color: rgb(49, 120, 115); border-color: rgb(49, 120, 115);';
        case 'interested':
          return 'color: rgb(30, 144, 255); border-color: rgb(30, 144, 255);';
        default:
          return 'color: rgb(0, 0, 0); border-color: rgb(0, 0, 0);';
      }
    },
  },
  computed: {
    formattedDate() {
      return this.$moment(this.item.date).format('yyyy-MM-DD');
    },
    formattedDateShipp() {
      return this.$moment(this.item.date).format('yyyy-MM-DD');
    },
  },
};
</script>
<style scoped>
[class*='toggle__dot-'] {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked~[class*='toggle__dot-'] {
  transform: translateX(100%);
  background-color: #63b3ed;
}

.tab-cc {
  margin-bottom: 40px;
  margin-top: 10px;
}
</style>
